// 用于操作模板中心搜索框历史记录的读写
// 大、小搜索框操作的都是同一个

const DATA_KEY = 'SEARCH_HISTORY'

const hasStorage = () => {
  try {
    window.localStorage.getItem(DATA_KEY)
    return true
  } catch (error) {
    return false
  }
}

/**
 * 读取搜索历史记录
 * @returns {Array<{text: string; timestamp: number}>}
 */
export const readHistories = () => {
  if (hasStorage()) {
    if (window.localStorage.getItem(DATA_KEY) !== null) {
      return JSON.parse(window.localStorage.getItem(DATA_KEY))
    } else {
      return []
    }
  }
}

/**
 * 新增一条搜索记录，未处理空记录
 * @param {{text: string; timestamp: number}} history
 */
export const writeHistory = (history) => {
  const prev = readHistories()
  // 取前5个
  prev.splice(4, prev.length)
  const duplicatedIndex = prev.findIndex((item) => item.text === history.text)
  // 去重
  if (duplicatedIndex >= 0) {
    prev.splice(duplicatedIndex, 1)
  }
  prev.push(history)
  // 按照时间戳降序
  prev.sort((a, b) => b.timestamp - a.timestamp)
  window.localStorage.setItem(DATA_KEY, JSON.stringify(prev))
}

/**
 * 清空所有搜索历史记录
 */
export const clearHistories = () => {
  window.localStorage.removeItem(DATA_KEY)
}
